import actions from './actions'
import mutations from './mutations'

const store = {
  state() {
    return {
      task: 'order_number' // alphabetical, dueDate
    }
  },
  actions,
  mutations
}

export default store

export * from './actionTypes'
export * from './mutationTypes'
